import { createReducer } from "redux-create-reducer";

import {
  GET_WATCH_LIST_ENTRIES,
  CLEAR_WATCH_LIST_ENTRIES,
  DELETE_WATCH_LIST_ENTRY,
  SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS,
  GET_WATCH_LIST_ENTRIES_COUNT,
  GET_WATCH_LIST_ENTRY_BY_ID,
  CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES,
  CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES,
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES,
} from "../types";
import { ENTRY_TYPE } from "../constants/watchListEntryConstants";

const initialState = {
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    type: ENTRY_TYPE.NATURAL_PERSON,
    nationalityId: null,
    minimumMatchingPercentage: null,
  },
  entries: [],
  watchListEntry: [],
  isLoading: false,
  noEntriesMessage: "",
};

const watchListEntriesReducer = createReducer(initialState, {
  [SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS]: (state, { payload }) => ({
    ...initialState,
    filters: { ...state.filters, ...payload },
  }),
  [GET_WATCH_LIST_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES_COUNT.FULFILLED]: (state, { payload }) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_WATCH_LIST_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    entries: payload.data,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [DELETE_WATCH_LIST_ENTRY.FULFILLED]: (state, { payload }) => ({
    ...state,
    entries: state.entries.filter((n) => n.id !== payload.data.id),
  }),
  [CLEAR_WATCH_LIST_ENTRIES]: () => initialState,
  [GET_WATCH_LIST_ENTRY_BY_ID.FULFILLED]: (state, { payload }) => {
    var watchlist = payload.data[0];
    watchlist.category = watchlist.watchList.category;
    return {
      ...state,
      watchListEntry: [watchlist],
    };
  },
  [CHANGE_ITEMS_PER_PAGE_WATCHLIST_ENTRIES]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [CHANGE_CURRENT_PAGE_WATCHLIST_ENTRIES]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
});

export default watchListEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/watchListEntriesReducer.js